// src/components/TabBar/TabBar.js
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AiOutlineSearch, AiOutlineHeart } from 'react-icons/ai';
import { usePlaces } from '../../context/PlaceContext';
import './TabBar.css';

const TabBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  
  // Access the primaryPlace from PlaceContext
  const { primaryPlace } = usePlaces();
  
  // Determine active tab based on current path
  const isSearchActive = path === '/' || path.startsWith('/p/');
  const isFavoritesActive = path === '/favorites';
  
  // Handle search tab click
  const handleSearchClick = (e) => {
    // If coming from favorites page and we have a primary place with a slug,
    // navigate directly to that slug page
    if (path === '/favorites' && primaryPlace?.slug) {
      e.preventDefault();
      navigate(`/p/${primaryPlace.slug}`);
      return;
    }
    
    // If we're on home (/) and have a primary place, navigate to its place page
    if (path === '/' && primaryPlace?.slug) {
      e.preventDefault();
      navigate(`/p/${primaryPlace.slug}`);
    }
    
    // If we're already on a place slug page, prevent navigation (stay on the page)
    if (path.startsWith('/p/')) {
      e.preventDefault();
    }
  };
  
  // Handle favorites tab click
  const handleFavoritesClick = (e) => {
    // Check if there's state to preserve when navigating to favorites
    if (!isFavoritesActive && location.state?.returnToFavorites) {
      e.preventDefault();
      navigate('/favorites', { state: location.state.returnToFavorites });
    }
  };

  return (
    <div className="tab-bar">
      <Link 
        to="/" 
        className={`tab-item ${isSearchActive ? 'active' : ''}`}
        onClick={handleSearchClick}
      >
        <AiOutlineSearch size={24} />
        <span>search</span>
      </Link>
      <Link 
        to="/favorites" 
        className={`tab-item ${isFavoritesActive ? 'active' : ''}`}
        onClick={handleFavoritesClick}
      >
        <AiOutlineHeart size={24} />
        <span>favorites</span>
      </Link>
    </div>
  );
};

export default TabBar;